import { apiRequestActions } from '@ackee/redux-utils';

import { fetchFloorActivityTypes } from './types';

export default apiRequestActions(fetchFloorActivityTypes, { isDetailRequest: true });
